<template>
  <button class="active_btn" @click.stop="openModal">
    <img :src="src" class="active_icon" loading="lazy" />
    <p>{{ qty }}</p>
  </button>
</template>

<script>
export default {
  name: "CommentBtn",
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    src() {
      return this.post.value?.is_comment
        ? "/comment-filled.svg"
        : "/comment.svg";
    },
    qty() {
      return this.post.comments_qty || 0;
    },
  },
};
</script>

<style>
.active_btn {
  display: flex;
  align-items: center;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 100px;
  font-size: 14px;
  padding: 6px 14px;
  font-weight: 700;
  cursor: pointer;
  border: none;
  transition: all var(--transition-time) ease;
}

.active_btn.active {
  background-color: rgba(255, 255, 255, 0.35);
}

.active_btn:hover {
  background-color: rgba(255, 255, 255, 0.3);
}

.active_btn p {
  margin: 0;
}

.active_icon {
  width: 25px;
  height: 22px;
  margin-right: 6px;
}
</style>
